
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Ja, wenn die Migräneattacken die Lebensqualität mindestens dreimal pro Monat stark beeinträchtigen, regelmässig länger als 72 Stunden dauern oder nicht auf die akute Behandlung ansprechen, wird eine medikamentöse Vorbeugung sogar empfohlen. Das bedeutet dann jedoch nicht, dass keine Schmerzattacken mehr auftreten. Aber die Abstände dazwischen können sich dank der Vorbeugung verlängern oder die Symptome abschwächen. Als wirksam gilt eine Prophylaxe, wenn sie mehr als 50 Prozent der Anfälle verhindert. Das erreichen bestenfalls 60 von 100 Betroffenen. Beurteilt wird der Erfolg erst nach zweimonatiger Einnahme der verträglichen Höchstdosis.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;